import { useEffect } from 'react';

// Largeur de carte visée, écart entre cartes, marge mini et largeur max du carrousel.
const TARGET_CARD = 250;
const GAP = 16; // doit correspondre à --bb-gap
const MIN_MARGIN = 20;
const MAX_TRACK = 1400;

// En dessous de cette largeur, mode « smartphone » : 1 carte + aperçu de la
// suivante (au lieu d'un nombre entier de cartes centrées).
const MOBILE_MAX = 600;
const MOBILE_MARGIN = 16;
const MOBILE_CARD_RATIO = 0.82; // ~1 carte + 18 % de la suivante visible

/**
 * Calcule une largeur de carrousel égale à un nombre ENTIER de cartes, et
 * ajuste finement la largeur de carte pour remplir exactement cette piste.
 * Les valeurs sont posées sur :root via --bb-track / --bb-card, sans état
 * React (donc sans re-render ni rechargement des données au resize).
 */
export default function useGridMetrics() {
  useEffect(() => {
    const apply = () => {
      const vw = document.documentElement.clientWidth;
      const root = document.documentElement.style;

      if (vw <= MOBILE_MAX) {
        // Mode smartphone : la piste occupe presque toute la largeur, et la
        // carte fait ~82 % de la piste pour laisser dépasser la suivante.
        const track = vw - 2 * MOBILE_MARGIN;
        root.setProperty('--bb-track', `${track}px`);
        root.setProperty('--bb-card', `${Math.round(track * MOBILE_CARD_RATIO)}px`);
        return;
      }

      const available = Math.min(vw - 2 * MIN_MARGIN, MAX_TRACK);
      const cards = Math.max(1, Math.round((available + GAP) / (TARGET_CARD + GAP)));
      const card = (available - (cards - 1) * GAP) / cards;
      root.setProperty('--bb-track', `${available}px`);
      root.setProperty('--bb-card', `${card}px`);
    };

    apply();
    window.addEventListener('resize', apply);
    return () => window.removeEventListener('resize', apply);
  }, []);
}
